import React from "react";
import MainLogo from "../brand/MainLogo";
import PillarSymbol from "../brand/PillarSymbol";
import { STORY_WELLNESS, STORY_WALK, BRAND_MISSION, BRAND_VISION, BRAND_VALUES, PILLARS } from "../brand/tokens";

const AboutPage = () => (
  <main className="site-main site-main--cream" data-testid="page-about">
    <section className="about-hero">
      <p className="eyebrow">ABOUT · RONA WELLNESS</p>
      <h1>The story of<br />Rona Wellness.</h1>
      <p className="lede">Two stories, one heart — the parent brand, and the concept that began it all.</p>
      <div className="about-hero__logo">
        <MainLogo size={280} />
      </div>
    </section>

    <section className="about-stories">
      <article className="about-story about-story--parent" data-testid="about-story-wellness">
        <p className="eyebrow">01 · THE BRAND</p>
        <h2>{STORY_WELLNESS.title}</h2>
        {STORY_WELLNESS.lines.map((l, i) => <p key={i}>{l}</p>)}
        <p className="about-story__close"><em>{STORY_WELLNESS.close}</em></p>
      </article>

      <article className="about-story about-story--concept" data-testid="about-story-walk">
        <p className="eyebrow">02 · THE CONCEPT</p>
        <h2>{STORY_WALK.title}</h2>
        <p className="about-story__intro"><em>{STORY_WALK.intro}</em></p>
        {STORY_WALK.lines.map((l, i) => <p key={i}>{l}</p>)}
        <p className="about-story__close"><em>{STORY_WALK.close}</em></p>
        <p className="about-story__mantra">{STORY_WALK.mantra}</p>
      </article>
    </section>

    <section className="about-mvv">
      <div className="section__head">
        <p className="eyebrow">MISSION · VISION · VALUES</p>
        <h2>The compass beneath the brand.</h2>
      </div>
      <div className="mvv">
        <div className="mvv__card mvv__card--mission">
          <p className="eyebrow">MISSION</p>
          <h3>Why we walk.</h3>
          <p>{BRAND_MISSION}</p>
        </div>
        <div className="mvv__card mvv__card--vision">
          <p className="eyebrow">VISION</p>
          <h3>Where we walk to.</h3>
          <p>{BRAND_VISION}</p>
        </div>
        <div className="mvv__card mvv__card--values">
          <p className="eyebrow">VALUES</p>
          <h3>How we walk.</h3>
          <div className="mvv__chips">
            {BRAND_VALUES.map((v, i) => <span className="mvv__chip" key={i}>{v}</span>)}
          </div>
        </div>
      </div>
    </section>

    <section className="about-pillar">
      <PillarSymbol size={100} />
      <h3>Faith · Strength · Hope</h3>
      <p>{PILLARS}</p>
    </section>
  </main>
);

export default AboutPage;
